webpackJsonp([0],{

/***/ "1Sp+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2TpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  props: {
    type: {
      type: String,
      default: 'left'
    },
    speed: {
      type: Number,
      default: 20
    },
    imgData: {
      type: Array
    },
    margin: {
      type: String,
      default: '20px'
    },
    txtPos: {
      type: Array,
      default: ['10%', '10%']
    }

  },
  data: function data() {
    return {
      containerStyle: {
        width: '',
        height: '',
        overflow: 'hidden',
        zIndex: 999,
        position: 'relative'
      },
      ulStyle: {
        position: 'absolute',
        top: '0',
        height: '100%',
        width: ''
      },
      liStyle: {
        float: 'left',
        width: '',
        height: '100%',
        position: 'relative',
        paddingLeft: '20px',
        paddingTop: '20px'
      },
      txtStyle: {
        position: 'absolute',
        bottom: '20px',
        left: '20px',
        zIndex: '10000'
      },
      timer: {},
      img_data: {}
    };
  },
  created: function created() {
    var arr = [];
    this.imgData.forEach(function (item) {
      arr.push(item);
    });
    this.imgData.forEach(function (item) {
      arr.push(item);
    });
    this.img_data = arr;
    this.containerStyle.width = '100%';
    this.containerStyle.height = '100%';
    this.ulStyle.height = '100%';
    this.ulStyle.width = '100%';
    this.txtStyle.left = this.txtPos[0];
    this.txtStyle.bottom = this.txtPos[1];

    if (this.type === 'left') {
      this.liStyle.paddingTop = '0';
    } else {
      this.liStyle.width = '100%';
      this.liStyle.height = 'auto';
      this.liStyle.paddingLeft = '0';
    }
  },
  mounted: function mounted() {
    this.trans(this.type);
  },

  methods: {
    trans: function trans(type) {
      var _this = this;
      var allImgLength = void 0;
      if (type === 'left') {
        allImgLength = this.img_data.length * this.$el.clientWidth;
        this.ulStyle.width = allImgLength + 'px';
      } else {

        allImgLength = this.img_data.length * this.$el.clientHeight;
        this.ulStyle.height = allImgLength + 'px';
      }
      this.timer = setInterval(function () {
        var num = 0;
        try {
          num = Number(_this.$refs.box.style[type].replace('px', ''));
          if (num <= -allImgLength / 2) {
            num = 0;
          }
          _this.$refs.box.style[type] = num - 1 + 'px';
        } catch (e) {}
      }, this.speed);
    },
    mouseIn: function mouseIn() {
      clearInterval(this.timer);
    },
    mouseO: function mouseO() {
      this.trans(this.type);
    }
  }
});

/***/ }),

/***/ "JgdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello",on:{"mouseover":_vm.mouseIn,"mouseout":_vm.mouseO}},[_c('div',{style:(_vm.containerStyle)},[_c('div',{ref:"box",style:(_vm.ulStyle)},_vm._l((_vm.img_data),function(item,index){return _c('div',{key:index,style:(_vm.liStyle)},[_c('img',{staticClass:"imgStyle",attrs:{"src":item.img,"alt":""}}),_vm._v(" "),_c('div',{style:(_vm.txtStyle)},[_vm._v(_vm._s(item.title))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JhYR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("ajUD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_5_vue_loader_lib_template_compiler_index_id_data_v_d118d71a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Srrb");
function injectStyle (ssrContext) {
  __webpack_require__("JhYR")
}
var normalizeComponent = __webpack_require__("o7Pn")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_5_vue_loader_lib_template_compiler_index_id_data_v_d118d71a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("2HEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Srrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("Vue-img-slider  Horizental")]),_vm._v(" "),_c('vue-img-slider',{staticStyle:{"width":"100%","height":"400px"},attrs:{"type":'left',"margin":"'20px'","speed":10,"imgData":_vm.demoData,"txtPos":['40%','10%']}}),_vm._v(" "),_c('h3',[_vm._v("Vue-img-slider  Vertical")]),_vm._v(" "),_c('vue-img-slider',{staticStyle:{"width":"400px","height":"400px","margin-left":"400px"},attrs:{"type":'top',"margin":"'20px'","speed":10,"imgData":_vm.demoData,"txtPos":['40%','10%']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ajUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueImgSlider_vue__ = __webpack_require__("ok9J");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      demoData: [{
        img: 'http://f12.baidu.com/it/u=1981748892,3031683197&fm=72',
        title: '图片1'
      }, {
        img: 'http://f10.baidu.com/it/u=3243370105,1125765815&fm=72',
        title: '图片2'
      }, {
        img: 'http://f12.baidu.com/it/u=1981748892,3031683197&fm=72',
        title: '图片3'
      }, {
        img: 'http://f10.baidu.com/it/u=3243370105,1125765815&fm=72',
        title: '图片4'
      }]
    };
  },
  components: {
    VueImgSlider: __WEBPACK_IMPORTED_MODULE_0__components_VueImgSlider_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "ok9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_script_index_0_VueImgSlider_vue__ = __webpack_require__("2TpJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_5_vue_loader_lib_template_compiler_index_id_data_v_7d48a889_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_template_index_0_VueImgSlider_vue__ = __webpack_require__("JgdC");
function injectStyle (ssrContext) {
  __webpack_require__("1Sp+")
}
var normalizeComponent = __webpack_require__("o7Pn")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d48a889"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_script_index_0_VueImgSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_5_vue_loader_lib_template_compiler_index_id_data_v_7d48a889_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_5_vue_loader_lib_selector_type_template_index_0_VueImgSlider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.924f540317ffc1d5e2a7.js